import { render, staticRenderFns } from "./historychart.vue?vue&type=template&id=b94dcea6&scoped=true&"
import script from "./historychart.vue?vue&type=script&lang=js&"
export * from "./historychart.vue?vue&type=script&lang=js&"
import style0 from "./historychart.vue?vue&type=style&index=0&id=b94dcea6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94dcea6",
  null
  
)

export default component.exports